import request from '@/utils/request'

export function selectBacklitCharactersSet(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/backlitCharacters/selectBacklitCharactersSet?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}
export function addBacklitCharactersSet(data) {
    return request({
        url: `api/serviceCenter/backlitCharacters/addBacklitCharactersSet`,
        method: 'post',
        data,
    })
}

export function upDateBacklitCharactersSet(data) {
    return request({
        url: `api/serviceCenter/backlitCharacters/upDateBacklitCharactersSet`,
        method: 'post',
        data,
    })
}

export function bathDeleteBacklitCharactersSet(data) {
    return request({
        url: `api/serviceCenter/backlitCharacters/bathDeleteBacklitCharactersSet`,
        method: 'post',
        data,
    })
}







